import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Heading from '../../../components/common/Heading/head';

const mapStateToProps = () => ({});
function mapDispatchToProps() {}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withRouter(compose(withConnect)(Heading));
